import { Grid } from '@material-ui/core';
import PageTitle from 'components/PageTitle';
import i18n from 'i18n';
import { newClientRequest } from 'modules/clients/actions';
import React from 'react';
import { connect } from 'react-redux';
import Form from '../Form';

interface Props {
  newClientRequest: ({ values }) => void;
}

const AddClient = ({ newClientRequest }: Props) => {
  const onSubmit = values => {
    newClientRequest({ values });
  };

  return (
    <Grid container>
      <Grid
        container
        direction="row"
        alignItems="center"
        justify="space-between"
      >
        <PageTitle
          title={i18n.t('ADD_CLIENT_KEY')}
          subtitle={i18n.t('ADD_CLIENT_DESCRIPTION_KEY')}
        />
      </Grid>

      <Form onSubmit={onSubmit} />
    </Grid>
  );
};

export default connect(null, { newClientRequest })(AddClient);
